import { z } from "zod";

export const EXTENSION_CONNECTION_PROTOCOL = 1;
export const EXTENSION_CONNECTION_MIN_VERSION = "0.1.13";
export const ExtensionConnectionRequestSchema = z.object({
  source: z.literal("xiaoman-web"), protocol: z.literal(1), id: z.string().uuid(),
  action: z.enum(["status", "open"]),
}).strict();
export type ExtensionConnectionRequest = z.infer<typeof ExtensionConnectionRequestSchema>;

export const ExtensionConnectionStatusSchema = z.object({
  version: z.string().regex(/^\d+\.\d+\.\d+(\.\d+)?$/),
  apiOrigin: z.string().url(),
  auth: z.enum(["signed_out", "authenticated", "refresh_required", "expired", "unknown"]),
  service: z.enum(["ready", "unavailable", "unconfigured", "demo"]),
  canOpen: z.boolean(), checkedAt: z.number().finite(),
}).strict();
export type ExtensionConnectionStatus = z.infer<typeof ExtensionConnectionStatusSchema>;
export const ExtensionConnectionResponseSchema = z.object({
  source: z.literal("xiaoman-extension"), protocol: z.literal(1), id: z.string().uuid(),
  result: z.discriminatedUnion("kind", [
    z.object({ kind: z.literal("status"), status: ExtensionConnectionStatusSchema }).strict(),
    z.object({ kind: z.literal("opened") }).strict(),
    z.object({ kind: z.literal("error"), code: z.enum(["OPEN_UNAVAILABLE", "USER_GESTURE_REQUIRED", "CONNECTION_FAILED"]) }).strict(),
  ]),
}).strict();
export type ExtensionConnectionResponse = z.infer<typeof ExtensionConnectionResponseSchema>;

export function connectionVersionCompatible(version: string): boolean {
  if (!/^\d+\.\d+\.\d+(\.\d+)?$/.test(version)) return false;
  const actual = version.split(".").map(Number), minimum = EXTENSION_CONNECTION_MIN_VERSION.split(".").map(Number);
  for (let i = 0; i < minimum.length; i++) {
    if (actual[i]! > minimum[i]!) return true;
    if (actual[i]! < minimum[i]!) return false;
  }
  return true;
}
